// extracted by mini-css-extract-plugin
module.exports = {"blinker":"blinker--1qvYg","spinner":"spinner--1uBYB","neonFlicker":"neonFlicker--2s6RO"};